import { Route } from "@angular/router";
import { Permissions } from "../../access/shared/authorization/permissions";
import { BordereauxComponent } from "./bordereaux.component";

export const BordereauxRouting: Route = {
    path: 'bordereaux', component: BordereauxComponent,
    data: {
        breadcrumb: "Bordereaux",
        'role': [
            Permissions.ROLE_ANETT,
        ],
    }
};
